import Faq from '@/components/landing/faq'
import Features from '@/components/landing/features'
import HeroSection from '@/components/landing/herosection'
import LandingPageWrapper from '@/components/landing/landing-page-wrapper'
import MobileDownload from '@/components/landing/mobile-download'
import Pricing from '@/components/landing/pricing'
import { createFileRoute } from '@tanstack/react-router'
// import logo from '../logo.svg'

export const Route = createFileRoute('/')({
  component: App,
})

function App() {
  // const api = useTRPC()
  // const { data } = useQuery({ ...api.user.testGreeting.queryOptions() })
  // console.log('>>> testGreeting data', data)

  return (
    <LandingPageWrapper>
      <HeroSection />
      <MobileDownload />
      <Features />
      <Pricing />
      <Faq />
    </LandingPageWrapper>
  )
}
